import * as tslib_1 from "tslib";
import setBlockedDomainsOption from '../actions/setBlockedDomainsOption';
import store from '../store/store';
import { getMailboxJunkEmailConfiguration } from 'owa-junkmail-configuration';
import { getFallbackValueIfNull } from 'owa-options-core';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import { EditSendersAndDomains, isEmailAddress, } from 'owa-mail-option-common';
import { OptionDescription } from 'owa-options-controls';
var BlockedDomainsFull = /** @class */ (function (_super) {
    tslib_1.__extends(BlockedDomainsFull, _super);
    function BlockedDomainsFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChangeBlockedDomains = function (blockedDomains) {
            setBlockedDomainsOption(blockedDomains);
        };
        return _this;
    }
    BlockedDomainsFull.prototype.render = function () {
        var domains = getFallbackValueIfNull(this.props.optionState.blockedDomains, this.props.junkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) { return !isEmailAddress(item); }));
        return (React.createElement("div", null, domains && (React.createElement("div", null,
            React.createElement(OptionDescription, null, strings.options_junkEmail_blockedDomains),
            React.createElement(EditSendersAndDomains, { items: domains, onItemsChanged: this.onChangeBlockedDomains, mode: 1 /* DomainOnly */ })))));
    };
    BlockedDomainsFull = tslib_1.__decorate([
        reactive({
            optionState: function () { return store; },
            junkEmailConfiguration: function () { return getMailboxJunkEmailConfiguration(); },
        })
    ], BlockedDomainsFull);
    return BlockedDomainsFull;
}(React.Component));
export default BlockedDomainsFull;
//# sourceMappingURL=BlockedDomainsFull.js.map